// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__13h1m","title":"ClientCherryInfo_title__3nCGr","itemText":"ClientCherryInfo_itemText__1eW9a"};